export enum ClientAccountType {
  KddiAccount = 'KddiAccount',
}
